"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _lodash = _interopRequireDefault(require("lodash"));

var _default2 = {
  props: {
    usePreset: {
      type: Boolean,
      default: true
    },
    networkList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    connection: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      name: '',
      presetNetworks: [],
      showCustom: true,
      willEmit: false
    };
  },
  computed: {
    presetServer: {
      set: function set(newVal) {
        if (newVal === 'custom') {
          this.name = '';
          this.connection.server = '';
          this.connection.port = 6697;
          this.connection.tls = true;
          this.showCustom = true;
        } else {
          var addr = this.parseFormatted(newVal);
          this.name = addr.name;
          this.connection.server = addr.server;
          this.connection.port = addr.port;
          this.connection.tls = addr.tls;
          this.showCustom = false;
        }
      },
      get: function get() {
        return this.showCustom ? 'custom' : this.toUri(this.connection);
      }
    }
  },
  created: function created() {
    if (this.networkList) {
      this.importUris(this.networkList);
    } // If the given network is in the preset server list, select it


    var con = this.connection;

    if ((0, _find.default)(_lodash.default).call(_lodash.default, this.presetNetworks, function (s) {
      var match = s.server === con.server && s.port === con.port && s.tls === con.tls;
      return match;
    })) {
      this.showCustom = false;
    }
  },
  methods: {
    toUri: function toUri(s) {
      var _context, _context2;

      return (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(s.server, ":")).call(_context2, s.tls ? '+' : '')).call(_context, s.port);
    },
    toggleTls: function toggleTls() {
      this.connection.tls = !this.connection.tls; // Switching the port only if were currently using the most common TLS/plain text ports

      if (this.connection.tls && this.connection.port === 6667) {
        this.connection.port = 6697;
      } else if (!this.connection.tls && this.connection.port === 6697) {
        this.connection.port = 6667;
      }
    },
    // parseFormatted - Parse freenode|irc.freenode.net:+6697 links
    parseFormatted: function parseFormatted(input) {
      var ret = {
        name: '',
        server: '',
        port: 6667,
        tls: false
      };
      var val = input;
      var pipePos = (0, _indexOf.default)(val).call(val, '|');

      if (pipePos > -1) {
        ret.name = val.substr(0, pipePos);
        val = val.substr(pipePos + 1);
      }

      var colonPos = (0, _indexOf.default)(val).call(val, ':');

      if (colonPos === -1) {
        ret.server = val;
        val = '';
      } else {
        ret.server = val.substr(0, colonPos);
        val = val.substr(colonPos + 1);
      }

      if (val[0] === '+') {
        ret.tls = true;
        val = val.substr(1);
      }

      if (val.length > 0) {
        ret.port = (0, _parseInt2.default)(val, 10);
        val = '';
      }

      if (!ret.name) {
        ret.name = ret.server;
      }

      return ret;
    },
    importUris: function importUris(serverList) {
      var _this = this;

      // [ 'freenode|irc.freenode.net:+6697', 'irc.snoonet.org:6667' ]
      var servers = (0, _map.default)(serverList).call(serverList, function (s) {
        return _this.parseFormatted(s);
      });
      this.$set(this, 'presetNetworks', servers);
    }
  }
};
exports.default = _default2;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ServerSelector"]
window._kiwi_exports.components.ServerSelector = exports.default ? exports.default : exports;
